// =======================================
// DATA TYPES
// =======================================

export interface Contact {
  id: number;
  first_name: string;
  last_name: string;
  email: string | null;
  phone: string | null;
  client: {
    id: number;
    company_name: string;
  };
  created_at: string;
}

export interface ClientWithCount {
  id: number;
  company_name: string;
  city: string | null;
  state: string | null;
  postcode: string | null;
  address_type: string | null;
  contact_count: number;
  created_at: string;
}

export interface PaginationInfo {
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  has_next: boolean;
  has_previous: boolean;
}

// =======================================
// COMPONENT CONFIGURATION
// =======================================

export interface ColumnConfig {
  type: 'text' | 'badge';
  label: string;
  order: number;
}

// =======================================
// CONSTANTS
// =======================================

export const DEFAULT_PAGE_SIZE = 25;
export const SEARCH_DEBOUNCE_DELAY = 300;

// =======================================
// COLUMN CONFIGURATIONS
// =======================================

export const contactColumns: Record<string, ColumnConfig> = {
  name: {
    type: 'text',
    label: 'Name',
    order: 1
  },
  client: {
    type: 'text',
    label: 'Client',
    order: 2
  },
  email: {
    type: 'text',
    label: 'Email',
    order: 3
  },
  phone: {
    type: 'text',
    label: 'Phone',
    order: 4
  },
  created_at: {
    type: 'text',
    label: 'Created',
    order: 5
  }
};

export const clientColumns: Record<string, ColumnConfig> = {
  company_name: {
    type: 'text',
    label: 'Company Name',
    order: 1
  },
  location: {
    type: 'text',
    label: 'Location',
    order: 2
  },
  contact_count: {
    type: 'text',
    label: 'Contacts',
    order: 3
  },
  created_at: {
    type: 'text',
    label: 'Created',
    order: 4
  }
};
